import types from './types';

function globalDebtReducer(state, action) {
  switch(action.type) {
    case types.SET_SEGMENT:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, segmento: action.segmento}}
    case types.SET_EXTRACT:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, estrato: action.estrato}}
    case types.SET_RESIDENCE_TYPE:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, tipoVivienda: action.tipoVivienda}}
    case types.SET_POSICION_HOGAR:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, posicionHogar: action.posicionHogar}}
    case types.SET_EDUCATIONAL_LEVEL:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, nivelEscolaridad: action.nivelEscolaridad}}
    case types.SET_SIMULATION:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, simulation: action.simulation}}
    case types.SET_HOUSING_CLASS:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, claseVivienda: action.claseVivienda}}
    case types.SET_FINANCIAL_COMMITMENTS:
      return {...state, centralInformation: {...state.centralInformation, financialCommitments: action.financialCommitments}}
    case types.SET_FINANCE_INFORMATION_ONE:
      return {...state, financeInformationOne: {...state.financeInformationOne, otrosIngresosCerficados: action.data.otrosIngresosCerficados, descuentosPrestacionales: action.data.descuentosPrestacionales, descuentosNomina: action.data.descuentosNomina}}
    case types.SET_FINANCE_INFORMATION_TWO:
      return {...state, financeInformationTwo: action.data}
    case types.SET_DOCUMENT_TYPE:
      return {...state, centralInformation: {...state.centralInformation, tipoDocumento: action.tipoDocumento}}
    case types.SET_ARCHIVE:
      return {...state, centralInformation: {...state.centralInformation, archive: [action.file[0]]}}
    case types.REMOVE_ARCHIVE:
      return {...state, centralInformation: {...state.centralInformation, archive: []}}
    case types.SET_DOCUMENT_TYPE_INCOME:
      return {...state, otherCertifiedIncome: {...state.otherCertifiedIncome, tipoDocumento: action.tipoDocumento}}
    case types.SET_ARCHIVE_INCOME:
      return {...state, otherCertifiedIncome: {...state.otherCertifiedIncome, archive: [action.file[0]]}}
    case types.REMOVE_ARCHIVE_INCOME:
      return {...state, otherCertifiedIncome: {...state.otherCertifiedIncome, archive: []}}
    case types.SET_MORTGAGE_PAYMENT:
      return {...state, centralInformation: {...state.centralInformation, cuotasHipotecarias: action.cuotasHipotecarias}}
    case types.SET_OTHER_CERTIFIED:
      return {...state, otherCertifiedIncome: action.data}
    case types.SET_MORTGAGE_CREDIT:
      return {...state, financeInformationTwo: {...state.financeInformationTwo, [action.name]: action.date}}
    case types.SET_CREDIT:
      return {...state, credit: action.credit }
    case types.SET_LAST_CREDIT:
      return {...state, lastCredit: action.lastCredit }
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation }
    case types.SET_GLOBAL_DEBIT_CALCULATION:
      return {...state, centralInformation: {...state.centralInformation, calculation: action.calculation}}
    case types.SET_BASIC_REQUEST_INFORMATION:
      return {...state, basicRequestInformation: {...state.basicRequestInformation, adoSegmentCode: action.adoSegmentCode}}
    default:
      return state;
  }
}

export default globalDebtReducer;
